import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export default function AdminLoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { login, loading, error } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    const ok = await login(email, password);
    if (ok) navigate('/admin/dashboard');
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ width: '100%', maxWidth: 360 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--accent3)' }}>Adeona</div>
          <div style={{ fontSize: 13, color: 'var(--text3)' }}>Admin Portal</div>
        </div>
        <div className="card">
          <h2 style={{ fontSize: 18, marginBottom: 4 }}>Sign In</h2>
          <p style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 20 }}>Access the applications dashboard</p>
          <form onSubmit={handleSubmit}>
            <div className="field">
              <label>Email Address</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@adeona.lk" required />
            </div>
            <div className="field">
              <label>Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" required />
            </div>
            {error && <div style={{ background: '#fff5f5', border: '1px solid #ffcdd2', borderRadius: 'var(--rs)', padding: '10px 12px', fontSize: 13, color: 'var(--red)', marginBottom: 12 }}>{error}</div>}
            <button type="submit" className="btn btn--primary btn--full" disabled={loading} style={{ borderRadius: 'var(--rs)' }}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
